import React, { useState, useContext } from "react";
import AppContext from "../../context/context";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tabs,
  Tab,
  Box,
  Stack,
  CircularProgress,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import TxtField from "../TxtField";

// services
import { editchannel } from "../../service/channel.service";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const generalFields = [
  { name: "display_name", label: "Display Name" },
];

const rtmpFields = [
  { name: "rtmp_in", label: "RTMP In" },
  { name: "rtmp_out", label: "RTMP Out" },
];

const srtFields = [
  { name: "srt_in", label: "SRT In" },
  { name: "srt_out", label: "SRT Out" },
];

const hlsFields = [
  { name: "hls", label: "HLS" },
  { name: "preview_url", label: "Preview URL" },
  { name: "redirect_url", label: "Redirect URL" },
];

const limitFields = [
  { name: "max_rtmp", label: "Max RTMP" },
  { name: "max_srt", label: "Max SRT" },
];

const tabFieldMap = {
  0: rtmpFields,
  1: srtFields,
  2: hlsFields,
  3: limitFields,
};

const EditChannel = ({ open, onClose, callback, channel }) => {
  // store variables
  const { store } = useContext(AppContext);
  const { user } = store;

  // state variables
  const [activeTab, setActiveTab] = useState(0);
  const [chnl, setChnl] = useState(channel);
  const [_err, setErr] = useState(false);
  const [creating, setcreating] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setChnl({
      ...chnl,
      [name]: value,
    });
  };

  const handleFeatureChange = (e) => {
    const { name, value } = e.target;
    setChnl({
      ...chnl,
      "feature": {
        ...chnl["feature"],
        [name]: value,
      }
    });
  };

  const _editChannel = async () => {
    setcreating(true);
    const status = await editchannel(chnl, user);
    if (status === "failed") {
      setErr(true);
    } else {
      callback();
      closeDialog();
    }
    setcreating(false);
  };

  const closeDialog = () => {
    setErr(false);
    setcreating(false);
    onClose();
  };

  React.useEffect(() => {
    setChnl(channel);
  }, [channel]);

  const handleTabChange = (_, newValue) => {
    setActiveTab(newValue);
  };

  const renderField = ({ name, label, disabled }) => (
    <TxtField
      key={name}
      id={name}
      name={name}
      label={label}
      value={chnl?.[name] ?? ""}
      disabled={disabled}
      onChange={handleChange}
      fullWidth
    />
  );

  const renderFeatureField = ({ name, label }) => (
    <TxtField
      key={name}
      id={name}
      name={name}
      label={label}
      value={chnl?.feature?.[name] ?? ""}
      onChange={handleFeatureChange}
      type="number"
      fullWidth
    />
  );

  if (!channel?.name) {
    return <></>;
  }


  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      aria-labelledby="edit-channel-form-title"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="edit-channel-form-title">Edit channel: {chnl?.name?.toUpperCase()}</DialogTitle>
      <DialogContent>
        {_err && <p style={{ color: "red" }}>{_err}</p>}

        <Stack spacing={2} sx={{ mb: 3, mt: 2 }}>
          {generalFields.map(renderField)}
        </Stack>

        <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            variant="fullWidth"
            aria-label="channel edit sections"
          >
            <Tab label="RTMP" />
            <Tab label="SRT" />
            <Tab label="HLS" />
            <Tab label="Limits" />
          </Tabs>
        </Box>

        <Stack spacing={2}>
          {activeTab === 3
            ? limitFields.map(renderFeatureField)
            : (tabFieldMap[activeTab] || []).map(renderField)}
        </Stack>
      </DialogContent>
      <DialogActions>
        {
          creating ? <CircularProgress sx={{marginRight : "50%"}} /> : (<>
            <Button
              onClick={closeDialog}
              variant="outlined"
              color="primary"
              disableElevation
              disabled={creating}
              sx={{ textTransform: "none" }}
            >
              Close
            </Button>
            <Button
              onClick={_editChannel}
              variant="contained"
              color="primary"
              disableElevation
              disabled={creating}
              sx={{ textTransform: "none" }}
            >
              Save
            </Button>
          </>)
        }
      </DialogActions>
    </Dialog>
  );
};

export default EditChannel;